import ArrayEditor from './array'
import AssetEditor from './asset'
import CheckboxEditor from './checkbox'
import ChoicesEditor from './choices'
import DatasetEditor from './dataset'
import HotspotEditor from './hotspot'
import LargeArrayEditor from './large-array'
import MultipleEditor from './multiple'
import NumberEditor from './number'
import ObjectEditor from './object'
import RadioEditor from './radio'
import SelectEditor from './select'
import StringEditor from './string'
import TableEditor from './table'
import TagsEditor from './tags'
import EnumSourceHelperEditor from './enum-source-helper'
import NestedArrayEnumSourceHelper from './nested-array-enum-source-helper'
import CSVArrayEditor from './csv-array'
import Header from './header'
import TypeSelectorEditor from './type-selector'
import UUIDEditor from './uuid'
import StepperEditor from './stepper'
import SelectChoices from './select-choices'

export default {
  array: ArrayEditor,
  asset: AssetEditor,
  checkbox: CheckboxEditor,
  choices: ChoicesEditor,
  dataset: DatasetEditor,
  largeArray: LargeArrayEditor,
  hotspot: HotspotEditor,
  multiple: MultipleEditor,
  number: NumberEditor,
  object: ObjectEditor,
  radio: RadioEditor,
  select: SelectEditor,
  selectChoices: SelectChoices,
  stepper: StepperEditor,
  string: StringEditor,
  table: TableEditor,
  tags: TagsEditor,
  enumSourceHelper: EnumSourceHelperEditor,
  nestedArrayEnumSourceHelper: NestedArrayEnumSourceHelper,
  csvArray: CSVArrayEditor,
  header: Header,
  typeSelector: TypeSelectorEditor,
  uuid: UUIDEditor
}
